import { useTranslation } from 'react-i18next';
const OverlayGeneral = () => {
    const {t} = useTranslation();
    return (
        <div>
            <div className="overlayText">
                {t('generalDentistryText')}
            </div>
        </div>
    )
}

export default OverlayGeneral;